import React, { useState } from 'react';
import Card from '@src/components/Card';
import SearchInput from '@src/new-components/SearchInput';
import NotificationDialog from '@src/components/NotificationDialog';
import VoiceCloneInput from '@src/containers/VoiceCloneInput';
import { Box } from '@mui/material';
import { Search, AddRounded } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import Typography from '@src/new-components/Typography';
import CommonButton from '@src/new-components/Button';
import Tabs from '@src/new-components/Tabs';
import {
  INSTANT_VOICE_CLONE,
  PRO_VOICE_CLONE,
} from '@src/constants/voiceCloning';
import { StyledVoiceCloningList } from './index.style';

const VoiceCloningList = () => {
  const { t } = useTranslation();
  const [search, setSearch] = useState('');
  const [showPopupInstantVoiceCloning, setShowPopupInstantVoiceCloning] =
    useState(false);
  const [activeTab, setActiveTab] = useState(INSTANT_VOICE_CLONE);

  const handleOpenPopupInstantVoiceCloning = () => {
    setShowPopupInstantVoiceCloning(true);
  };

  const handleClosePopupInstantVoiceCloning = () => {
    setShowPopupInstantVoiceCloning(false);
  };

  const handleChangeSearch = (e) => {
    setSearch(e.target.value);
  };

  const handleTabChange = (tab) => {
    setActiveTab(tab);
  };

  // TODO: Get count from backend
  const tabs = [
    {
      label: 'instantVoiceClone',
      count: 2,
      name: INSTANT_VOICE_CLONE,
    },
    {
      label: 'proVoiceClone',
      name: PRO_VOICE_CLONE,
    },
  ];

  return (
    <StyledVoiceCloningList>
      <Card padding="40px" className="voice-cloning-list-card">
        <Typography variant="body-20-bold" color="textPrimary">
          {t('voiceList')}
        </Typography>
        <Box className="voice-search-bar">
          <SearchInput
            value={search}
            name="search"
            placeholder="searchByVoiceName"
            iconStart={<Search />}
            onChange={handleChangeSearch}
            styleInput={{ paddingLeft: '12px' }}
            className="voice-search-input"
          />
          <CommonButton
            onClick={handleOpenPopupInstantVoiceCloning}
            variant="containedSmall"
            color="primary"
            customStyle={{
              fontWeight: 700,
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
            }}
          >
            <AddRounded />
            {t('createVoice')}
          </CommonButton>
        </Box>

        <Tabs tabs={tabs} activeTab={activeTab} onChange={handleTabChange} />
      </Card>
      {showPopupInstantVoiceCloning && (
        <NotificationDialog
          hiddenIcon
          contentComponent={
            <VoiceCloneInput
              closePopupInstantVoiceCloning={
                handleClosePopupInstantVoiceCloning
              }
            />
          }
          open
        />
      )}
    </StyledVoiceCloningList>
  );
};

export default VoiceCloningList;
